interface tableNumber {
    pageCurrent: number,
    dataLength: number,
    index: number,
    limit: number,
    totalData: number
  }

  export const TableNumber = ({ pageCurrent, dataLength, index, limit, totalData }: tableNumber) => limit <= dataLength ? String(pageCurrent * dataLength + (index + 1) - dataLength) :  totalData - dataLength + index + 1
